import type { ValidationResult } from '@openx/components-targeting/Targeting/shared/BulkAdd/types.ts';
import type { ListData } from '@openx/types/inventoryList.ts';
import { formatDataForValidation } from './formatDataForValidation.ts';

export const validateBulkInput = (
  bulkInput: string,
  listData: ListData[],
  validateInput: (input: string[], state: string[]) => ValidationResult
) => {
  if (!bulkInput) {
    return;
  }

  const { dataFromState, dataFromInput } = formatDataForValidation(listData, bulkInput);

  return validateInput(dataFromInput, dataFromState);
};
